import React from 'react';
import { Link } from 'react-router-dom';
import { Gift } from 'lucide-react';
import { MyRewards } from '../Promotions';
import { accountHook } from '../../lib/domHooks';

/** Bonuslarım: oyuncunun çevrimi süren bonusu, freespin ve freebet hakları.
 *
 * Hesap menüsündeki "Bonuslarım" bir süre Profilim'e `#bonuslarim` çapasıyla
 * gidiyordu; çapa yalnızca adrese yazılıyor, ödülü olmayan oyuncuda hiçbir
 * şey göstermiyordu ve menüde iki madde birden seçili görünüyordu. Ödüllerin
 * artık kendi adresi vardır ve hiçbir hak yokken kampanyalara yönlendiren bir
 * boş durum çizilir.
 */
const EmptyRewards = () => (
  <div className="pusu-card p-8 text-center" {...accountHook('empty')}>
    <Gift size={28} className="mx-auto mb-3 text-[var(--pusu-gold)]" />
    <div className="font-semibold">Aktif bonusunuz bulunmuyor</div>
    <p className="account-muted text-sm mt-1">
      Çevrimi süren bir bonusunuz, freespin ya da freebet hakkınız olduğunda burada listelenir.
    </p>
    <Link to="/promosyonlar" className="gold-btn inline-flex mt-4 px-5 py-2.5 rounded-xl text-sm">
      Kampanyaları İncele
    </Link>
  </div>
);

const MyBonuses = () => (
  <div className="pusu-panel p-6" {...accountHook('panel')}>
    <div className="mb-5" {...accountHook('page-header')}>
      <h2 className="text-xl font-bold gold-text" {...accountHook('title')}>Bonuslarım</h2>
      <p className="text-sm text-gray-400" {...accountHook('subtitle')}>
        Bonus çevriminiz, freespin ve freebet haklarınız
      </p>
    </div>
    <div className="profile-rewards" {...accountHook('rewards')}>
      <MyRewards emptyState={<EmptyRewards />} />
    </div>
  </div>
);

export default MyBonuses;
